module.exports = __webpack_public_path__ + "static/messangers-bed8606dc6f87448c20e484c462401b1.png";